import React from "react";
import AndroidProjects from "./Projects/AndroidProjects";
import WebProjects from "./Projects/WebProjects";
import WritingProjects from "./Projects/WritingProjects";

const Portfolio = () => {
  return (
    <section id="portfolio" className="portfolio">
      <div className="container">
        <h2 className="section-title fade-up">Our Portfolio</h2>

        <p className="section-subtitle fade-up delay-1">
          A showcase of our successfully delivered projects across
          <strong> Android, iOS, Web platforms, and Writing & Research Domains</strong>, built with
          performance, quality, and precision in mind.
        </p>

        {/* MOBILE APPS */}
        <div className="portfolio-block fade-up delay-2">
          <h3 className="block-title">
            Android & iOS Applications
          </h3>
          <p className="block-desc">
            High-quality mobile applications developed for Android and iOS,
            focusing on smooth performance, secure architecture, and modern UI.
          </p>
          <AndroidProjects />
        </div>

        {/* WEB PROJECTS */}
        <div className="portfolio-block fade-up delay-3">
          <h3 className="block-title">
            Web Applications & Platforms
          </h3>
          <p className="block-desc">
            Scalable, responsive, and business-driven web applications built
            using the latest frontend and backend technologies.
          </p>
          <WebProjects />
        </div>

        {/* WRITING PROJECTS */}
        <div className="portfolio-block fade-up delay-4">
          <h3 className="block-title">
            Writing & Research Publications
          </h3>
          <p className="block-desc">
            Professional content writing, SEO copywriting, and comprehensive thesis
            & academic research publications crafted to the highest quality standards.
          </p>
          <WritingProjects />
        </div>
      </div>

      <style jsx>{`
        .portfolio {
          padding: 120px 0;
          background: #020617;
          color: #e5e7eb;
          text-align: center;
        }

        .section-title {
          font-size: 2.8rem;
          font-weight: 800;
          color: #22d3ee;
        }

        .section-subtitle {
          max-width: 750px;
          margin: 20px auto 80px;
          font-size: 1.1rem;
          opacity: 0.85;
        }

        .section-subtitle strong {
          color: #22d3ee;
        }

        .portfolio-block {
          margin-bottom: 90px;
        }

        .block-title {
          font-size: 2rem;
          margin-bottom: 14px;
          color: #22d3ee;
        }

        .block-desc {
          max-width: 700px;
          margin: 0 auto 45px;
          font-size: 1rem;
          opacity: 0.85;
          line-height: 1.6;
        }

        /* ANIMATIONS */
        .fade-up {
          opacity: 0;
          transform: translateY(40px);
          animation: fadeUp 0.8s ease forwards;
        }

        .delay-1 {
          animation-delay: 0.2s;
        }
        .delay-2 {
          animation-delay: 0.4s;
        }
        .delay-3 {
          animation-delay: 0.6s;
        }
        .delay-4 {
          animation-delay: 0.8s;
        }

        @keyframes fadeUp {
          to {
            opacity: 1;
            transform: translateY(0);
          }
        }

        /* MOBILE */
        @media (max-width: 768px) {
          .section-title {
            font-size: 2.2rem;
          }

          .block-title {
            font-size: 1.6rem;
          }

          .portfolio-block {
            margin-bottom: 70px;
          }
        }
      `}</style>
    </section>
  );
};

export default Portfolio;
